import { useMutation } from "@tanstack/react-query";
import { updateRoles as apiEditRoles } from "../../api/apiRoles";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useUpdateRoles() {
    const navigate = useNavigate();

    const {
        mutate: editRoles,
        isPending: isUpdate,
        data: results,
        error,
    } = useMutation({
        mutationFn: ({ req, id }) => apiEditRoles(req, id),
        onSuccess: (response) => {
            toast.success(response.message);
            navigate('/roles');
        },
        onError: (err) => {
            console.error("Error:", err);
            const msg = getErrorMessageFromAxiosError(err, "Something Wont Wrong!");
            toast.error(msg);
        },

    });

    return { editRoles, isUpdate, error, results };
}
